// extracted by mini-css-extract-plugin
module.exports = {"bannerStyle":"GlobalBanner_bannerStyle__YDrQ_"};